import Swiper from 'swiper'
import { Keyboard, Manipulation } from 'swiper/modules'

export default class SingleCarCoverSlider {
  constructor() {
    this.thumbs = new Swiper('.thumb-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      threshold: 20,
      loop: true,
      slideToClickedSlide: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false
      },
      modules: [Keyboard, Manipulation]
    })

    this.slider = new Swiper('.main-swiper', {
      slidesPerView: 1,
      threshold: 20,
      centeredSlides: true,
      loop: true,
      spaceBetween: 24,
      modules: [Manipulation]
    })

    this.syncSliders(this.thumbs, this.slider)
    this.syncSliders(this.slider, this.thumbs)

    this.createPhyron()
    this.handleVideoSize()

    window.addEventListener('resize', () => {
      this.handleVideoSize()
    })
  }

  syncSliders (source, target) {
    source.on('setTransition', (swiper, duration) => {
      if (this.isSyncing || target.destroyed) {
        return
      }

      this.isSyncing = true
      target.setTransition(duration)
      this.isSyncing = false
    })

    source.on('setTranslate', () => {
      if (this.isSyncing || target.destroyed) {
        return
      }

      this.isSyncing = true
      this.followSlider(source, target)
      this.isSyncing = false
    })
  }

  getLoopPosition (swiper) {
    const translate = -swiper.translate
    const grid = swiper.snapGrid
    let index = 0

    for (let i = 0; i < grid.length - 1; i++) {
      if (grid[i] <= translate) {
        index = i
      }
    }

    const distance = grid[index + 1] - grid[index]

    return {
      realIndex: Number(swiper.slides[index].getAttribute('data-swiper-slide-index')),
      progress: distance ? (translate - grid[index]) / distance : 0
    }
  }

  followSlider (source, target) {
    const { realIndex, progress } = this.getLoopPosition(source)
    const buffer = Math.ceil(target.slidesPerViewDynamic() / 2)
    let index = target.getSlideIndexByData(realIndex)

    if (index < buffer || index + 1 >= target.slides.length - buffer) {
      const duration = target.wrapperEl.style.transitionDuration

      target.setTransition(0)
      target.loopFix({ activeSlideIndex: index, byMousewheel: true })
      target.wrapperEl.getBoundingClientRect()
      target.wrapperEl.style.transitionDuration = duration
      index = target.getSlideIndexByData(realIndex)
    }

    const grid = target.snapGrid
    const next = grid[index + 1] ?? grid[index]
    const translate = -(grid[index] + (next - grid[index]) * progress)

    target.updateProgress(translate)
    target.setTranslate(translate)
    target.updateActiveIndex()
    target.updateSlidesClasses()
  }

  createPhyron () {
    const showPhyronVideos = document.querySelector('.mtt-single-car-cover')?.getAttribute('data-show-phyron')
    const id = document.querySelector('.mtt-single-car-cover')?.getAttribute('data-id')
    const swiper = document.querySelector('.mtt-single-car-cover .main-swiper')

    if (showPhyronVideos === 'false' || showPhyronVideos == null || id.length <= 0 || swiper == null) {
      return
    }
    const videoTag = `
       <div class="swiper-slide object-fit video-tag">
          <div style="display: none">
            <video
                class="phyron-video"
                data-campaign="nellemann"
                data-product-key="${id}"
                data-file="1024x768"
                data-tracking-source="phyron"
                data-callback="phyronCallback"           
            </video>
          </div>
      </div>
    `

    const thumbTag = `
      <div class="swiper-slide video-thumb">
        <div class="object-fit">
          <img src="" alt="">
        </div>
      </div>
    `
    this.slider.prependSlide(videoTag)
    this.thumbs.prependSlide(thumbTag)
    this.slider.slideToLoop(0)
    this.thumbs.slideToLoop(0)
  }

  handleVideoSize () {
    const iframes = document.querySelectorAll('.swiper-slide iframe')

    if (iframes.length <= 0) {
      return
    }

    iframes.forEach(iframe => {
      const parent = iframe.parentNode

      const height = parent.clientHeight
      iframe.style.height = `${height}px`
      iframe.style.width = `100%`
    })
  }
}
